import { useQuery } from '@tanstack/react-query';

import type { StationBoardType, StopType } from '@/types';

import { DEFAULT_QUERY_OPTIONS } from '@/query/constants';
import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';

const useGetData = <T>(
  queryKey: string,
  id: string | null,
  path: (id: string | null) => string,
  enabled = false
) =>
  useQuery<T>({
    queryKey: [queryKey, id],
    queryFn: async () => {
      const response = await axiosInstance.get<T>(path(id));

      return response.data;
    },
    enabled,
    ...DEFAULT_QUERY_OPTIONS,
  });

export const useGetStationBoard = (id: string | null) =>
  useGetData<StationBoardType[]>('station-board', id, API_ROUTES.stationBoard, !!id);

export const useGetStationData = ({ id, enabled }: { id: string | null; enabled?: boolean }) => {
  return useGetData<StopType>('stop', id, API_ROUTES.stationDetails, enabled);
};
